export default __webpack_public_path__ + "static/media/aiagentsforbusiness.aab92eea.png";